import React from 'react'
import LivePlanModifyWeekly from '../../plan/LivePlanModifyWeekly'
import V3PlanRouteShell from './V3PlanRouteShell'

export default function V3LivePlanModifyWeeklyPage() {
  return (
    <V3PlanRouteShell>
      {React.createElement(LivePlanModifyWeekly as any)}
    </V3PlanRouteShell>
  )
}

